import {
  GO_TO_LEVEL,
  NEXT_LEVEL,
  PREV_LEVEL,
  ANCHOR_TO,
  TOGGLE_VISIBILITY,
  SET_HTML,
  TOGGLE_SELF_CONTAINED_MODE,
  REPLACE_PALETTE,
} from './action_type';

export const goToLevel = level => ({
  type: GO_TO_LEVEL,
  level,
});

export const nextLevel = () => ({
  type: NEXT_LEVEL,
});

export const prevLevel = () => ({
  type: PREV_LEVEL,
});

export const anchorTo = (node, offset) => ({
  type: ANCHOR_TO,
  node,
  offset,
});

export const toggleVisibility = () => ({
  type: TOGGLE_VISIBILITY,
});

export const setHTML = html => ({
  type: SET_HTML,
  html,
});

export const toggleSelfContainedMode = () => ({
  type: TOGGLE_SELF_CONTAINED_MODE,
});

export const replaceHighlighters = highlighters => ({
  type: REPLACE_PALETTE,
  highlighters,
});
